<template>
  <div class="space-galaxy">
    <!-- :style="{ 'background-image': 'url(' + backgrounds[Math.round(Math.random())].url + ')' }" -->
    <div v-if="Math.round(Math.random()) === 1" class="body pasture-field">
      <div class="body-score">
        <img
          v-for="index in quiz.questionsCorrect"
          :key="index + 1"
          src="@/assets/tests/elements-1-4/star-yellow.png"
        />
        <img v-for="index in quiz.wrongQuestions" :key="index + 5" src="@/assets/tests/elements-1-4/star-grey.png" />
      </div>
      <div class="body-info">
        <div v-if="nextLesson" class="text">
          <h1>{{ $t('resultsQuiz.approved.title') }}</h1>
          <p>{{ $t('resultsQuiz.approved.msg') }}</p>
        </div>
        <div v-else class="text">
          <h1>{{ $t('resultsQuiz.notApproved.title') }}</h1>
          <p>{{ $t('resultsQuiz.notApproved.msg') }}</p>
        </div>
        <div class="navigation-btn">
          <navigation-btns class="star" :disabled-btn="!nextLesson" :disabled-btn-next="nextLesson"></navigation-btns>
        </div>
      </div>
    </div>
    <div v-else class="body space">
      <div class="body-score">
        <img
          v-for="index in quiz.questionsCorrect"
          :key="index + 1"
          src="@/assets/tests/elements-1-4/star-yellow.png"
        />
        <img v-for="index in quiz.wrongQuestions" :key="index + 5" src="@/assets/tests/elements-1-4/star-grey.png" />
      </div>
      <div class="body-info">
        <div v-if="nextLesson" class="text">
          <h1>{{ $t('resultsQuiz.approved.title') }}</h1>
          <p>{{ $t('resultsQuiz.approved.msg') }}</p>
        </div>
        <div v-else class="text">
          <h1>{{ $t('resultsQuiz.notApproved.title') }}</h1>
          <p>{{ $t('resultsQuiz.notApproved.msg') }}</p>
        </div>
        <div class="navigation-btn">
          <BtnsNavigation class="star" :disabled-btn="!nextLesson" :disabled-btn-next="nextLesson"></BtnsNavigation>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BtnsNavigation from './BtnsNavigation.vue';

export default {
  components: {
    BtnsNavigation,
  },
  props: {
    quiz: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    nextLesson() {
      return this.quiz.average >= 75;
    },
  },
};
</script>
<style lang="scss" scoped>
.space-galaxy {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .body {
    height: 600px;
    max-width: 1150px;
    width: 85%;
    background-size: 100% 100%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    &.space {
      background-image: url('~@/assets/tests/instructions/pasture_field.png');
    }
    &.pasture-field {
      background-image: url('~@/assets/tests/instructions/space.png');
    }
    .body-score {
      display: flex;
      justify-content: center;
      img {
        height: 110px;
        width: 110px;
        margin: 0 3%;
      }
      img:nth-child(1),
      img:nth-child(4) {
        margin-top: 5%;
      }
    }
    .body-info {
      font-family: 'comfortaaregular';
      margin: 15px auto;
      background-color: #ffffff;
      width: 500px;
      height: 280px;
      border-radius: 15px;
      padding: 3% 5%;
      display: flex;
      -webkit-align-items: center;
      align-items: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      .text {
        text-align: center;
      }
      .navigation-btn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }
  }
}

@media (max-width: 1026px) {
  .space-galaxy {
    position: relative;
  }
}
</style>
